export interface ICompanyFormInfo {
  name: string; // 企业名称

  description: string; // 企业描述
  creditCode: string; // 社会信用代码
  uploadValue: ICompanyUploadValue; // 营业执照文件
  contactName: string;
  contactIDCode: string;
  contactPhone: string;
}

export interface ICompanyUploadValue {
  fileName?: string;
  url: string;
}

export enum CompanyType {
  SelfDeveloped = 1, // 自研
  SecondParty = 2, // 二方
  PostInvestment = 3, // 投后
}

export type ICompanyRejectType =
  | 'name'
  | 'description'
  | 'creditCode'
  | 'businessLicenseImageUrl'
  | 'contactName'
  | 'contactPhone'
  | 'contactIDCode';

export interface ICompanyRejectReason {
  id?: number;
  type: ICompanyRejectType | undefined;
  reason: string;
}
